import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const FuelRequestReportModule = new Module({
  id: 'fuel-filling',
  name: 'Fuel Filling Report',
  path: 'fuel-filling',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/FuelRequest'))
  ),
  actions: {
    addRecord: {
      id: 'add-fuel-request',
      name: 'add-fuel-request',
      label: 'Add Fuel Request'
    }
  }
});
